import {LayoutTestimonialColumnDark} from './LayoutTestimonialColumnDark';
import {LayoutTestimonialColumnLight} from './LayoutTestimonialColumnLight';
import {LayoutTestimonialImageLeft} from './LayoutTestimonialImageLeft';
import {LayoutTestimonialSliderLarge} from './LayoutTestimonialSliderLarge';
import {LayoutTestimonialSliderSmall} from './LayoutTestimonialSliderSmall';
import {LayoutTestimonialStack} from './LayoutTestimonialStack';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Testimonial';

export const TestimonialColumnDark = {
  category,
  displayName: 'Testimonial Column Dark',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialColumnDark,
  layout: LayoutTestimonialColumnDark,
};

export const TestimonialColumnLight = {
  category,
  displayName: 'Testimonial Column Light',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialColumnLight,
  layout: LayoutTestimonialColumnLight,
};

export const TestimonialImageLeft = {
  category,
  displayName: 'Testimonial Image Left',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialImageLeft,
  layout: LayoutTestimonialImageLeft,
};

export const TestimonialSliderLarge = {
  category,
  displayName: 'Testimonial Slider Large',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialSliderLarge,
  layout: LayoutTestimonialSliderLarge,
};

export const TestimonialSliderSmall = {
  category,
  displayName: 'Testimonial Slider Small',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialSliderSmall,
  layout: LayoutTestimonialSliderSmall,
};

export const TestimonialStack = {
  category,
  displayName: 'Testimonial Stack',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTestimonialStack,
  layout: LayoutTestimonialStack,
};
